import React from 'react'
import { Link } from 'gatsby'
import { motion } from 'framer-motion'
import { parentList } from '../utils/parentNode'

interface Props {
  className?: string
  data: any
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  activeMenu: string
  setActiveMenu: (value: string) => void
}

const opacityVariant = {
  hidden: { opacity: 0, x: 5 },
  visible: { opacity: 1, x: 0 },
}

const motionTransition = {
  ease: 'easeOut',
  duration: 0.35,
}

const NavigationDropdown: React.FC<Props> = ({
  className,
  data,
  isOpen,
  setIsOpen,
  activeMenu,
  setActiveMenu,
}) => {
  const handleClose = () => {
    setIsOpen(false)
    setActiveMenu('')
  }

  return (
    <div
      className={`
				nav-dropdown nav-dropdown--desktop
				hidden lg:block absolute
				w-full overflow-hidden
				py-5 px-12 xl:px-12 bg-white border-gray-light border-b h-62
				${className}
			`}
      onMouseEnter={() => {
        setIsOpen(true)
      }}
      onMouseLeave={() => {
        handleClose()
      }}
    >
      <div className='nav-dropdown__content relative h-full mx-auto max-w-screen-2xl'>
        {parentList(data?.primaryMenu.menuItems.nodes).map((menu) => {
          const nodeSize: number = menu.childItems.nodes.length
          const gridColsSize: string = nodeSize <= 5 ? 'grid-cols-x3' : 'grid-cols-x4'

          return (
            <motion.div
              key={menu.path}
              initial='hidden'
              animate={activeMenu === menu.path ? 'visible' : 'hidden'}
              variants={opacityVariant}
              transition={motionTransition}
              className={`nav-dropdown__link-group absolute h-full w-full
                    ${activeMenu === menu.path ? '' : 'pointer-events-none'}
                  `}
            >
              <div className={`dropdown-links grid ${gridColsSize} grid-rows-2`}>
                {menu.childItems.nodes.map((childItem: any) => {
                  {
                    if (childItem?.acfMenuItem?.menuitemIsFeatured) {
                      return (
                        <div
                          key={childItem?.path}
                          className={`${childItem?.cssClasses.join(
                            ' '
                          )} border-r border-gray-light pr-6 mr-6`}
                        >
                          <Link
                            className={`inline-block rounded-lg h-40 cursor-pointer ${childItem?.acfMenuItem?.menuitemBackgroundClass}`}
                            to={childItem?.path}
                          >
                            <div className='flex h-full rounded-xl p-6'>
                              <img
                                alt={childItem?.acfMenuItem?.featuredImage?.altText}
                                className='mr-6'
                                height='150px'
                                width='124px'
                                src={childItem?.acfMenuItem?.featuredImage?.sourceUrl}
                              />
                              <div className='flex flex-col justify-around'>
                                <div>
                                  <h2 className='mb-1'>{childItem?.label}</h2>
                                  {childItem.description && (
                                    <p className='text-sm font-normal text-gray tracking-wide leading-relaxed'>
                                      {childItem?.description}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      )
                    }

                    if (childItem?.acfSocialicons?.hasSocialIcons) {
                      return (
                        <div key={childItem.path} className='flex items-center ml-4'>
                          {childItem?.acfSocialicons?.socialIcons.map((social: any) => {
                            return (
                              <a
                                className='mr-6'
                                key={social.socialIconLink}
                                href={social?.socialIconLink}
                                target='_blank'
                                rel='noreferrer noopener'
                              >
                                <span
                                  dangerouslySetInnerHTML={{ __html: social?.socialIconCode }}
                                ></span>
                              </a>
                            )
                          })}
                        </div>
                      )
                    }

                    return (
                      <Link
                        className={`flex flex-col justify-around ${childItem.cssClasses.join(
                          ' '
                        )} ${
                          childItem?.acfMenuItem?.menuitemBackgroundClass
                        } py-4 px-6 rounded-lg cursor-pointer`}
                        key={childItem?.path}
                        to={childItem?.path}
                      >
                        <div>
                          <h2 className='mb-1'>{childItem?.label}</h2>
                          {childItem.description && (
                            <p className='text-xs font-normal text-gray hidden xl:block'>
                              {childItem?.description}
                            </p>
                          )}
                        </div>
                      </Link>
                    )
                  }
                })}
              </div>
            </motion.div>
          )
        })}
      </div>
    </div>
  )
}

export default NavigationDropdown
